module.exports = __webpack_public_path__ + "img/stop.0088af80.svg";